import { IConfig } from '../../../repository/config';
import { IRestaurant, SplashConfigEnum } from '../../../repository/vendor';
import { getLocaleText } from '../../MultiLocale';

export interface ISplashConfig {
    theme: SplashConfigEnum;
    title: string;
    desc: string;
}

interface IProps {
    countryConfig?: IConfig;
    vendor?: IRestaurant;
    isBlackTheme?: boolean;
    lang?: string;
}

export const getSplashConfig = ({ countryConfig, vendor, isBlackTheme, lang }: IProps): ISplashConfig => {
    const getTheme = (): SplashConfigEnum => {
        if (!vendor && !countryConfig) {
            return SplashConfigEnum.Purple;
        }

        if (isBlackTheme) {
            return SplashConfigEnum.Black;
        }

        if (vendor?.config?.splashEnable) {
            return vendor.config.splashTheme || SplashConfigEnum.Purple;
        }

        if (vendor?.posVendor?.config?.splashEnable) {
            return vendor.posVendor?.config?.splashTheme || SplashConfigEnum.Purple;
        }

        if (countryConfig?.splashEnable) {
            return countryConfig.splashTheme || SplashConfigEnum.Purple;
        }

        return SplashConfigEnum.Purple;
    };

    const getTitle = (): string => {
        if (vendor?.config?.splashEnable) {
            return getLocaleText(vendor.config.splashTitle || '', lang || '', '') || '';
        }

        if (vendor?.posVendor?.config?.splashEnable) {
            return getLocaleText(vendor?.posVendor?.config?.splashTitle || '', lang || '', '') || '';
        }

        if (countryConfig?.splashEnable) {
            return getLocaleText(countryConfig.splashTitle || '', lang || '', '') || '';
        }

        return '';
    };

    const getDesc = (): string => {
        if (vendor?.config?.splashEnable) {
            return getLocaleText(vendor.config.splashDesc || '', lang || '', '') || '';
        }

        if (vendor?.posVendor?.config?.splashEnable) {
            return getLocaleText(vendor?.posVendor?.config?.splashDesc || '', lang || '', '') || '';
        }

        if (countryConfig?.splashEnable) {
            return getLocaleText(countryConfig.splashDesc || '', lang || '', '') || '';
        }

        return '';
    };

    return {
        theme: getTheme(),
        title: getTitle(),
        desc: getDesc(),
    };
};
